import { useApiCall } from "@jane/lib/src/api";
import { LearnModule } from "@jane/lib/src/api/repositories/learn-repository";
import { Checkbox } from "@jane/lib/src/components/form/Checkbox";
import { Input } from "@jane/lib/src/components/form/Input";
import {FC, useState} from "react";
import {config} from "../config";
import {CertificateEnum} from "../pages/learn/CertificateEnum";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {Autocomplete} from "../../../lib/src/components/form/auto-complete/Autocomplete";

export const EditLearnModuleModal: FC<{module: LearnModule, onFinished: () => void}> = (props) => {
  const {learn} = useApiCall(config)
  const [name, setName] = useState(props.module.name)
  const [type, setType] = useState(props.module.certificate_type)
  const [description, setDescription] = useState(props.module.description)
  const [mandatory, setMandatory] = useState(props.module.mandatory)
  const save = async () => {
    await learn.editModule(props.module.category_id, props.module.id, name, description, mandatory, props.module.chapters ?? [], type)
    props.onFinished()
  }

  const certificateTypes: { [key: string]: string } = Object.fromEntries(
    Object.entries(CertificateEnum)
  );

  return <div className={"flex flex-col space-y-3"}>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <Autocomplete label={'Certificaat type'} options={certificateTypes} value={type} onChange={(ct) => setType(ct)}/>
    <Input type={'textarea'} label={'Omschrijving'} value={description} onChange={setDescription} />
    <Checkbox label={'Verplicht onderwerp'} description={'Medewerkers zien dit onderdeel in hun app overzicht zolang ze het nog niet hebben afgerond.'} checked={mandatory} onChange={setMandatory} />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}